import { createSelector } from 'reselect'

export const getAuth = state => state.get('engagement').auth || {}

export const getAuthSuccess = createSelector([getAuth], data => data.get('success'))

export const getAuthError = createSelector([getAuth], data => data.get('error'))

export const getAutoLoginEnabled = createSelector([getAuth], data => data.get('autoLoginEnabled'))

export const getAuthConfig = createSelector([getAuth], data => data.get('authConfig'))

export const getAuthFederatedLogin = createSelector([getAuth], data => data.get('isFederatedLogin'))

export const getAuthValidateInviteLink = createSelector([getAuth], data =>
  data.get('inviteLinkValidation')
)

export const getAuthValid = createSelector([getAuth], data => data.get('valid'))

export const getAuthTypeFormHealthy = createSelector([getAuth], data => data.get('typeFormHealthy'))

export const getAuthJWT = createSelector([getAuth], data => data.get('JWT'))
